<template>
	<div class="page">
		<!-- your page -->
        <Head></Head>
        <div class="order">
            <div class="fixation">
                <div class="address">
                    <div class="title">
                        选择收货地址
                    </div>
                    <div class="addressArea">
                        <div class="item" v-for="item in address" :id="item.default" :data-id="item.id" @click="choose">
                            <div class="user" :data-id="item.id">
                                <div class="name" :data-id="item.id">
									{{item.name}}
                                </div>
                                <div class="phone" :data-id="item.id">
									{{item.phone}}
                                </div>
								<div class="itemBtn" :data-id="item.id">
									<div class="btn" :data-id="item.id" @click="Modify">
										修改
									</div>
									<div class="btn del" :data-id="item.id" @click="deleteThis">
										删除
									</div>
								</div>
                            </div>
                            <div class="detail" :data-id="item.id">
								{{item.detail}}
                            </div>
                            <div class="email" :data-id="item.id">
								{{item.email}}
                            </div>
                        </div>
                        <div class="newAddress" @click="newForm">
							<img src="../../assets/cart/add.png" alt="">
                        </div>
                    </div>
                </div>
                <div class="info">
                    <div class="title">
						确认商品信息
                    </div>
                    <div class="table">
                        <div class="tableTitle">
                            <div class="commodity">商品信息</div>
                            <div class="unit" v-if="from!='score'">单价</div>
							<div class="unit" v-if="from=='score'">所需积分</div>
                            <div class="nums">数量</div>
                            <div class="price">小计</div>
                        </div>
                        <div class="tableBody">
                            <div class="cItem" v-for="item in commodity">
								<div class="commodity">
	                                <div class="avatar">
	                                    <div class="avatarIn">
	                                    	<img :src="item.avatar" alt="">
	                                    </div>
	                                </div>
	                                <div class="commodityInfo">
	                                    <div class="name">
											{{item.name}}
	                                    </div>
	                                    <div class="tab">
											{{item.tab}}
	                                    </div>
	                                </div>
	                            </div>
	                            <div class="unit" v-if="from!='score'">
									{{item.unit}}
	                            </div>
								<div class="unit" v-if="from=='score'">
									{{item.score}}
								</div>
	                            <div class="nums">
									{{item.nums}}
	                            </div>
	                            <div class="price" v-if="from!='score'">
									{{item.price}}
	                            </div>
								<div class="price" v-if="from=='score'">
									{{item.totalScore}}
								</div>
                            </div>
                        </div>
                    </div>
                    <div class="remark">
                        <div class="remarkTitle">
							订单留言
                        </div>
                        <div class="textarea">
                            <textarea name="" id="" placeholder="请在此键入您的留言信息" v-model="remark"></textarea>
                        </div>
                    </div>
                    <div class="score" v-if="from!='score'">
                        <div class="radio">
                            <div class="radioIn" @click="scoreBtn">
                                <img src="../../assets/cart/duigou.png" alt="" v-if="scoreShow">
                            </div>
                        </div>
                        <div class="word">
							使用积分抵扣，{{score}}可抵扣{{scorePrice}}
                        </div>
                    </div>
                    <div class="result">
                        <div class="line" v-if="from!='score'">
							商品总价: <span>{{goods_amount}}</span>
                        </div>
						<div class="line" v-if="from=='score'">
							积分总计: <span>{{totalScore}}</span>
						</div>
                        <div class="line">
							配送费用: <span>{{cost}}</span>
                        </div>
                        <div class="line" v-if="from!='score'">
							积分抵扣: <span>{{dikou}}</span>
                        </div>
                        <div class="line" v-if="from!='score'">
							应付款金额: <span>{{amount}}</span>
                        </div>
						<div class="line" v-if="from=='score'">
							应付款金额: <span>{{cost}}</span>
						</div>
                    </div>
                </div>
                <div class="goPay">
                    <button @click="goPay" v-if="from!='score'" :data-id="1">去支付</button>
					<button @click="goPay" v-if="from=='score'" :data-id="2">去兑换</button>
                </div>
				<div class="newFormArea" v-if="newFormShow">
					<div class="newFormBox">
						<div class="newFormTitle">
							新增收货地址
							<img src="../../assets/index/close.png" alt="" @click="closeForm">
						</div>
						<div class="newForm">
							<div class="line">
								<div class="lineTitle">收货人姓名:</div>
								<div class="inputBox">
									<input type="text" placeholder="请输入收货人的姓名" v-model="name">
								</div>
							</div>
							<div class="line">
								<div class="lineTitle">电子邮箱:</div>
								<div class="inputBox">
									<input type="email" placeholder="请输入邮箱" v-model="email">
								</div>
							</div>
							<div class="line">
								<div class="lineTitle">手机号码:</div>
								<div class="inputBox">
									<input type="number" placeholder="请输入手机号" v-model="phone">
								</div>
							</div>
							<div class="line">
								<div class="lineTitle">地区选择:</div>
								<div class="inputBox">
									<select name="" id="" v-model="province" @change="changeP">
										<option v-for="item in provinceList" :value="item.id">{{item.name}}</option>
									</select>
									<select name="" id="" v-model="city" @change="changeC">
										<option v-for="item in cityList" :value="item.id">{{item.name}}</option>
									</select>
									<select name="" id="" v-model="area">
										<option v-for="item in areaList" :value="item.id">{{item.name}}</option>
									</select>
								</div>
							</div>
							<div class="line">
								<div class="lineTitle">详细地址:</div>
								<div class="inputBox">
									<input type="text" placeholder="请输入详细的街道地址门牌号" v-model="detail">
								</div>
							</div>
							<div class="line">
								<div class="lineTitle"></div>
								<div class="inputBox">
									<div class="defaultRadio">
										<div class="defaultIn" @click="setDefault">
											<img src="../../assets/person/select.png" alt="" v-show="defaultShow">
										</div>
									</div>
									<div class="defaultWord">
										设为默认
									</div>
								</div>
							</div>
							<div class="line">
								<div class="save" @click="saveAddress">
									保存
								</div>
							</div>
						</div>
					</div>
				</div>
            </div>
        </div>
        <Foot></Foot>
	</div>
</template>

<script>
	// your script
    import Head from '../../components/head.vue'
	import Foot from '../../components/foot.vue'
	export default {
		name: 'newOrder',
        components:{
			Head,Foot
		},
		data(){
			return {
				receive:{
					area_id:""
				},
                address:[],
                commodity:[],
                score:0,
                goods_amount:"0.00",
                cost:"0",
                scorePrice:"0",
                amount:"0.00",
				dikou:'0.00',
                newFormShow:false,
				scoreShow:false,
				defaultShow:false,
				province:"",
				provinceList:[],
				city:"",
				cityList:[],
				area:"",
				areaList:[],
				name:"",
				email:"",
				phone:"",
				detail:"",
				isDef:2,
				remark:"",
				bread:"确认订单",
				from:"",
				totalScore:0
			}
		},
		methods:{
			Modify(e){
				var id = e.target.dataset.id
				var token = this.token
				var data = {
					"token":token,
					"method":"user.getshipdetail",
					"id":id
				}
				var that = this
				this.request(data,function(res){
					if(res.status){
						that.name = res.data.name
						that.phone = res.data.mobile
						that.detail = res.data.address
						that.area = res.data.area_id
						that.email = res.data.email
						that.is_def = res.data.is_def
						that.newFormShow = true
						that.edit = false
						that.eid = id
					}else{
						var msg = res.msg
						that.globalTest('getshipdetail','error',msg,res.data)
					}
				})
			},
			deleteThis(e){
				var id = e.target.dataset.id
				var data = {
					"token":this.token,
					"id":id,
					"method":"user.removeship"
				}
				var that = this
				this.request(data,function(res){
					console.log(res)
					if(res.status){
						that.fetchAddress()
					}else{
						var msg = res.msg
						that.globalTest('user.removeship','error',msg,res.data)
					}
				})
			},
			goPay(e){
				var receive
				var conversion = e.target.dataset.id
				var address = this.address
				for (var i = 0; i < address.length; i++) {
					var item = address[i]
					if(item.default=="default"){
						receive = item
					}
				}
				var data = {
					cart_ids: this.ids,
					memo: this.remark,
					coupon_code:'',     //  优惠券兑换码  暂时没用到
					point:this.score,
					receipt_type: 1,     // receipt_type    1是快递配送，2是门店自提
					uship_id: receive.id,
					area_id: receive.area_id,
					token: this.token,
					method: 'order.create'
				}
				if(this.from=='score'){
					data['is_integral']=1
				}
				var that = this
				this.request(data,function(res){
					if(res.status){
						if(that.from!='score'){
							that.$router.push({path:"/pay",query:{order_id:res.data.order_id,type:"commodity",free:that.amount,from:that.from}})
						}else if(that.from=='score'&&that.cost!=0){
							that.$router.push({path:"/pay",query:{order_id:res.data.order_id,type:"commodity",free:that.cost,from:that.from}})
						}else{
							that.integralpay(res.data.order_id)
						}
					}else{
						var msg = res.msg
						that.globalTest('order.create','error',msg,res.data)
					}
				})
			},
			integralpay(oid){
				var data = {
					ids:oid,
					payment_code:'integralpay',
					payment_type:1,
					method:"user.pay",
					token:this.token
				}
				var that= this
				this.request(data,(res)=>{
					console.log(res)
					if(res.status){
						that.globalTest('兑换成功！','success','使用积分兑换成功！')
						that.$router.push({path:'/success',query:{}})
					}else{
						that.globalTest('user.pay','error',res.msg,res.data)
					}
				})
			},
			changeP(){
				var pid = this.province
				var data = {
					id:pid,
					method:"user.area"
				}
				var that = this
				this.request(data,function(res){
					console.log(res)
					if(res.status){
						that.cityList = res.data
						that.city = res.data[0].id
						that.changeC()
					}else{
						that.globalTest('user.area','error',res.msg,res.data)
					}
				})
			},
			changeC(){
				var cid = this.city
				var data = {
					id:cid,
					method:"user.area"
				}
				var that = this
				this.request(data,function(res){
					console.log(res)
					if(res.status){
						that.areaList = res.data
						that.area = res.data[0].id
					}else{
						that.globalTest('user.area','error',res.msg,res.data)
					}
				})
			},
			fetchProvince(){
				var data = {
					method:'user.area',
					id:''
				}
				var that = this
				this.request(data,function(res){
					console.log(res)
					if(res.status){
						that.provinceList = res.data
						that.province = res.data[0].id
						that.changeP()
					}else{
						that.globalTest('user.area','error',res.msg,res.data)
					}
				})
			},
			setDefault(){
				var defaultShow = this.defaultShow
				if(defaultShow){
					this.defaultShow = false
					this.isDef = 2
				}else{
					this.defaultShow = true
					this.isDef = 1
				}
			},
			saveAddress(){
				var method = ""
				var edit = this.edit
				var id = this.id
				if(edit){
					method = "user.vuesaveusership"
					id = ""
				}else{
					method = "user.editship"
					id = this.eid
				}
				if(this.phone.length!=11){
					this.globalTest('inputPhone','error','请填写正确的手机号')
					return
				}else if(this.name==''){
					this.globalTest('inputName','error','请填写姓名')
					return
				}else if(this.email==''){
					this.globalTest('inputEmail','error','请填写邮箱')
					return
				}else if(this.detail==''){
					this.globalTest('inputDetail','error','请填写详细地址')
					return
				}
				var data = {
					id:id,
					name : this.name,
					email : this.email,
					mobile : this.phone,
					area_id : this.area,
					address : this.detail,
					token : this.token,
					method : method,
					is_def : this.isDef
				}
				var that = this
				this.request(data,function(res){
					if(res.status){
						that.newFormShow = false
						that.name = '',
						that.email = '',
						that.phone = '',
						that.area = '',
						that.detail = '',
						that.fetchAddress()
					}else{
						var msg = res.msg
						that.globalTest(method,'error',msg,res.data)
					}
				})
			},
			closeForm(){
				this.newFormShow = false
			},
			newForm(){
				this.newFormShow = true
				this.edit = true
				this.fetchProvince()
			},
			scoreBtn(){
				var scoreShow = this.scoreShow
				var ids = this.ids
				if(scoreShow){
					this.fetchData()
					this.scoreShow = false
					this.dikou = "0.00"
				}else{
					var data = {
						ids: ids,
						area_id:this.receive.area_id?this.receive.area_id:'',
						coupon_code: '',
						point: this.score,
						receipt_type: 1,
						token: this.token,
						method: 'cart.getlist'
					}
					var that = this
					this.request(data,function(res){
						console.log(res)
						if(res.status){
							that.scoreShow = true
							that.goods_amount = res.data.goods_amount
							that.amount = res.data.amount
							that.dikou = res.data.point_money
						}else{
							var msg = res.msg
							that.globalTest('cart.getlist','error',msg,res.data)
						}
					})
				}
			},
			fetchUserPoint(){
				var data = {
					order_money: this.goods_amount,
					token: this.token,
					method: "user.getuserpoint"
				}
				var that = this
				this.request(data,function(res){
					if(res.status){
						that.scorePrice = res.point_rmb
						that.score = res.available_point
					}else{
						var msg = res.msg
						var msg = res.msg
						that.globalTest('user.getuserpoint','error',msg,res.data)
					}
				})
			},
			choose(e){
				var address = this.address
				var id = e.target.dataset.id
				for (var i = 0; i < address.length; i++) {
					var aid = address[i].id
					address[i].default = ""
					if(id==aid){
						address[i].default = "default"
					}
				}
				this.address = address
			},
			fetchAddress(){
				var token = this.token
				var data = {
					token : token,
					method : "user.getusership"
				}
				var address = this.address
				address = []
				var that = this
				this.request(data,function(res){
					if(res.status){
						var list = res.data
						for (var i = 0; i < list.length; i++) {
							var item = list[i]
							var def
							if(item.is_def==1){
								def = "default"
							}else{
								def = ""
							}
							var obj = {
								name:item.name,
								phone:item.mobile,
								detail:item.area_name+item.address,
								email:item.email,
								id:item.id,
								area_id:item.area_id,
								default:def
							}
							address.push(obj)
						}
						that.address = address
					}else{
						var msg = res.msg
						that.globalTest('user.getusership','error',msg,res.data)
					}
				})
			},
			fetchData(){
				var ids = this.ids
				var data = {
					ids: ids,
					area_id: this.receive.area_id?this.receive.area_id:'',
					coupon_code:'',
					point:0,
					receipt_type:1,
					token:this.token,
					method:'cart.getlist'
				}
				if(this.from=='score'){
					data['is_integral'] = 1
				}
				var that = this
				var commodity = this.commodity
				commodity = []
				var that = this
				this.request(data,function(res){
					if(res.status){
						var reList = res.data.list
						for (var i = 0; i < reList.length; i++) {
							var item = reList[i]
							var obj = {
								avatar:item.products.image_path,
								name:item.products.name,
								tab:item.products.spes_desc,
								unit:item.products.price,
								nums:item.nums,
								price:item.products.price*item.nums,
								score:item.integral_price,
								totalScore:parseFloat(item.integral_price)*item.nums
							}
							commodity.push(obj)
						}
						that.commodity = commodity
						that.cost = res.data.cost_freight
						that.amount = res.data.amount
						if(that.from=='score'){
							that.totalScore = res.data.integral_price
						}else{
							that.goods_amount = res.data.goods_amount
						}
						that.fetchUserPoint()
					}else{
						var msg = res.msg
						that.globalTest('cart.getlist','error',msg,res.data)
					}
				})
			}
		},
		beforeCreate: function() {
			//生命周期 -- 组件实例刚被创建，组件属性计算之前，如DATA属性等
		},
		created: function() {
			//生命周期 -- 组件实例创建完成，属性已绑定，但DOM还未生成，$el属性还不存在
		},
		beforeMount: function() {
			//模板编译/挂载之前
		},
		mounted: function() {
			//模板编译/挂载之后
			var ids = this.$route.query.cartIds
			var token = localStorage.getItem('token')
			this.token = token
			this.ids = ids
			this.from = this.$route.query.from
			this.fetchAddress()
			this.fetchData()
		},
		beforeUpdate: function() {
			//组件更新之前
		},
		updated: function() {
			//组件更新之后
		},
		activated: function() {
			// for keep-alive，组件被激活时调用
		},
		deactivated: function() {
			// for keep-alive，组件被移除时调用
		},
		beforeDestory: function() {
			// 组件销毁调用
		},
		destoryed: function() {
			// 组件销毁后调用
		}
	}
</script>

<style scoped>
	/* your css */
    .order{
        width: 100%;
        background: #F0F0F0;
    }
    .fixation{
        background: #FFFFFF;
        padding:10px;
        box-sizing: border-box;
    }
    .address{
        width: 100%;
		border-bottom: 1px solid #D3D3D3;
    }
    .title{
        width: 100%;
        height: 70px;
        line-height: 70px;
        font-size: 18px;
        font-weight: 600;
    }
    .addressArea{
        width: 100%;
        font-size: 0px;
        letter-spacing:-6px;
        padding-bottom:20px;
    }
    .addressArea .item{
        width: 380px;
        height: 130px;
        display: inline-block;
        vertical-align: top;
        font-size: 14px;
        letter-spacing: normal;
        margin-left: 10px;
        margin-top: 10px;
        border: 2px dashed #E3E3E3;
        padding: 10px;
        box-sizing: border-box;
    }
	.addressArea #default{
		background: url('../../assets/cart/border.png');
		background-repeat:no-repeat;
		background-size: 100% 100%;
		border: none;
	}
    .addressArea .item .user{
        width: 100%;
        height: 30px;
        line-height: 30px;
    }
    .addressArea .item .user .name{
        width: 30%;
        height: 100%;
        float: left;
    }
    .addressArea .item .user .phone{
        width: 40%;
        height: 100%;
        float: left;
    }
    .addressArea .item .user .itemBtn{
        width: 30%;
        height: 100%;
        float: left;
		position: relative;
    }
    .itemBtn .btn{
        width: 50%;
        height: 100%;
		position: absolute;
		left: 0px;
		top: 0px;
		z-index: 10;
        text-align: center;
        color: #036dee;
		cursor: pointer;
    }
	.itemBtn .btn:hover{
		background: #E0E0E0;
	}
	.itemBtn .del{
		left: 50%;
	}
    .addressArea .item .detail{
        width: 100%;
        line-height: 24px;
        min-height: 48px;
    }
    .newAddress{
        width: 130px;
        height: 130px;
        background: red;
        display: inline-block;
        vertical-align: top;
        font-size: 14px;
        letter-spacing: normal;
        margin-left: 10px;
        margin-top: 10px;
        border: 1px solid #C3C3C3;
        background: #F0F0F0;
        box-sizing: border-box;
    }
    .newAddress img{
        width: 50px;
        height: 50px;
        display: block;
        margin: 39px auto;
    }
    .info{
        width: 100%;
    }
    .table{
        width: 100%;
        box-sizing: border-box;
    }
    .tableTitle{
        width: 100%;
        height: 40px;
        border: 1px solid #D3D3D3;
		background: #daeaff;
        line-height: 40px;
    }
    .tableTitle .commodity{
        padding-left: 10px;
        box-sizing: border-box;
    }
    .commodity,.unit,.nums,.price{
        float: left;
        height: 100%;
    }
    .commodity{
        width: 578px;
        position: relative;
    }
    .unit,.nums,.price{
        width: 200px;
        text-align: center;
    }
    .tableBody{
        width: 100%;
    }
    .cItem{
        width: 100%;
        height: 110px;
        line-height: 110px;
        position: relative;
        border-bottom: 1px solid #e3e3e3;
    }
    .avatar{
        width: 110px;
        height: 100%;
        float: left;
    }
    .avatar .avatarIn{
        width: 90px;
        height: 90px;
        margin: 10px auto;
        overflow: hidden;
    }
    .avatar .avatarIn img{
        width: 100%;
    }
    .commodityInfo{
        width: 468px;
        height: 100%;
        float: left;
        padding:15px 0px;
        box-sizing: border-box;
    }
    .commodityInfo .name,.commodityInfo .tab{
        width: 100%;
        height: 40px;
        line-height: 20px;
    }
    .tableBody .unit,.tableBody .price{
        color: red;
    }
    .remark{
        width: 100%;
        height: 150px;
        position: relative;
        margin-top: 15px;
    }
    .remarkTitle{
        width: 100px;
        height: 100%;
        position: absolute;
        left: 0px;
        top: 0px;
        line-height: 30px;
        font-size: 16px;
        font-weight: 600;
    }
    .textarea{
        width: 100%;
        height: 100%;
        padding-left: 100px;
        box-sizing: border-box;
    }
    .textarea textarea{
        width: 100%;
        height: 100%;
        border:1px solid #B3B3B3;
        box-sizing: border-box;
        padding: 5px 10px;
        line-height: 24px;
    }
    .score{
        width: 100%;
        height: 50px;
        line-height: 50px;
        position: relative;
    }
    .score .radio{
        width: 30px;
        height: 100%;
        position: absolute;
    }
    .score .radio .radioIn{
        width: 20px;
        height: 20px;
        box-sizing: border-box;
        border:1px solid #b3b3b3;
        margin-top: 15px;
        border-radius: 50%;
    }
	.score .radio .radioIn img{
		width: 100%;
		height: 100%;
		display: block;
	}
    .score .word{
        width: 100%;
        height: 100%;
        padding-left: 30px;
        box-sizing: border-box;
        color: red;
    }
    .result{
        width: 100%;
		border-top: 1px solid #D3D3D3;
		border-bottom: 1px solid #D3D3D3;
    }
    .result .line{
        width: 100%;
        height: 40px;
        line-height: 40px;
        text-align:right;
    }
    .result .line span{
        color: red;
    }
    .goPay{
        width: 100%;
        height: 70px;
        padding-bottom: 50px;
    }
    .goPay button{
        width: 150px;
        height: 40px;
        float: right;
        background: #036DEE;
        color: white;
        border: none;
        margin-top: 15px;
    }
    .newFormArea{
        width: 100%;
        height: 100%;
        position: fixed;
        background: rgba(0, 0, 0, 0.4);
        left: 0px;
        top: 0px;
		z-index: 12;
    }
    .newFormBox{
        width: 500px;
        height: 430px;
        position: fixed;
        left: 50%;
        top: 50%;
        margin-left: -250px;
        margin-top: -215px;
        background: #FFFFFF;
    }
    .newFormBox .newFormTitle{
        width: 100%;
        height: 50px;
        color: #333333;
        padding:0px 10px;
        box-sizing: border-box;
        line-height: 50px;
        font-size: 16px;
		border-bottom: 1px solid #197AFF;
    }
    .newFormTitle img{
        width: 16px;
        height: 16px;
        float:right;
        margin-top: 17px;
        margin-right: 10px;
    }
    .newForm{
        width: 100%;
        height: 330px;
        padding: 0px 10px;
        box-sizing: border-box;
    }
    .newForm .line{
        width: 100%;
        height: 50px;
        line-height: 50px;
        position: relative;
    }
    .newForm .line .lineTitle{
        width: 80px;
        height: 100%;
        position: absolute;
        left: 0px;
        top: 0px;
		display: flex;
		justify-content: flex-end;
		padding-right: 5px;
		box-sizing: border-box;
    }
    .newForm .line .inputBox{
        width: 100%;
        height: 100%;
        padding-left: 80px;
        padding-top: 10px;
        box-sizing: border-box;
    }
    .newForm .line .inputBox input{
        width: 200px;
        height: 30px;
        display: block;
        border:1px solid #B3B3B3;
		padding-left: 5px;
		box-sizing: border-box;
    }
    .newForm .line .inputBox select{
        width: 100px;
        height: 30px;
        float: left;
        margin-left: 10px;
    }
    .newForm .line .inputBox select:nth-child(1){
        margin-left:0px;
    }
    .defaultRadio{
        width: 30px;
        height: 100%;
        float: left;
    }
    .defaultIn{
        width: 20px;
        height: 20px;
        border: 1px solid #b3b3b3;
        box-sizing: border-box;
        margin-top: 5px;
    }
	.defaultIn img{
		width: 100%;
		height: 100%;
		display: block;
	}
    .defaultWord{
        width: 100px;
        height: 40px;
        float: left;
        line-height: 30px;
    }
    .save{
        width: 150px;
        height: 40px;
        margin:0 auto;
        background: #333333;
        color: #FFFFFF;
        text-align: center;
        line-height: 40px;
        margin-top: 10px;
    }
</style>
